// @flow
import React from 'react';
import PortaOutPage from './components/PortaOutPage';
import I18n from '../../lib/i18n';

export default () => <PortaOutPage text={I18n.t('PortaOut.refused')} />;
